export enum TextScript {
    BASE = 'BASE',
    SUPER = 'SUPER',
    SUB = 'SUB',
}
